import React from 'react';
import Link from 'gatsby-link';

import config from '../utils/config';

const Home = () => (
  <div>
    <br />
    <span
      style={{
        fontFamily: "'Alex brush', cursive",
        fontSize: '80px',
        fontWeight: 'bold',
        color: config.site.textColor,
        lineHeight: '1em',
      }}>
      {config.personalInfo.bride + ' & ' + config.personalInfo.groom}
    </span>
    <br />
    <br />
    <br />
      <p style={{
          fontWeight: 'bold',
          fontFamily: "'Dancing Script', cursive",
          fontSize: '25px',
          color: config.site.textColor,
      }}>
          Thank you for joining us virtually! Here’s a brief timeline of our journey:
      </p>
    <img src={config.img.bridePic} alt={config.personalInfo.bride} />
      <br />
      <br />
      <br />
      <div style={{textAlign: 'right'}}>
          <p className="biotext">October 2017 - Gabriel moves from Amsterdam to Seattle.</p>
          <img src={config.img.space_needle} alt="SpaceNeedle" />
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">February 2, 2018 - Samara & Gabriel go on their first date in Fremont. They walk to the Troll.</p>
          <img src={config.img.troll} alt="Troll" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">March 2018 - They say “I love you” for the first time</p>
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">April 2018 - They spend their birthday visiting Sedona & the Grand Canyon.</p>
          <img src={config.img.sedona} alt="Sedona" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">June 2018 - Gabriel meets Samara’s parents & grandparents in Spokane.</p>
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">October 2018 - They dress up as Ariel & Eric for Halloween....(with Shady)</p>
          <img src={config.img.ariel} alt="Ariel" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">November 2018 - Westley joins the family (because of Shady) and they move to Fremont, right next to the Troll.</p>
          <img src={config.img.fremont} alt="Fremont" />
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">December 2018 - First Christmas!.</p>
          <img src={config.img.christmas} alt="Christmas" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">April 2019 - They go wine-tasting in Chelan for their birthday.</p>
          <img src={config.img.chelan} alt="Chelan" />
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">July 2019 - They spend a week in Northern California--Napa for a cousin’s wedding, exploring San Francisco, relaxing in Monterey, and driving through Big Sur.</p>
          <img src={config.img.napa} alt="Napa" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">September 2019 - They travel to Romania. Samara meet’s Gabriel’s Mom along with other friends and family. They visit special spots from his childhood.</p>
          <img src={config.img.romania} alt="Romania" />
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">October 2019 - For Halloween, they go as Han & Leia. Westley is Yoda.</p>
          <img src={config.img.yoda} alt="Yoda" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">December 24, 2019 - Gabriel proposes. Samara says “Yes!”</p>
          <img src={config.img.proposal} alt="Proposal" />
      </div>
      <div style={{textAlign: 'left'}}>
          <p className="biotext">February 2020 - Gabriel gets reconstructive knee surgery. Project manager that she is, Samara keeps them on a tight schedule during the first days of recovery.</p>
          <img src={config.img.surgery} alt="Surgery" />
      </div>
      <div style={{textAlign: 'right'}}>
          <p className="biotext">April 2020 - They start out their birthday rushing Samara to the hospital. She has a blood clot in her lung and is admitted to the hospital. He takes care of her for weeks as she recuperates.</p>
          <img src={config.img.hospital} alt="Hospital" />
      </div>
      <div style={{textAlign: 'center'}}>
          <p className="biotext">June 2020 - They decide, “We want to be married” and a month later… here we are!</p>
          <img src={config.img.rings} alt="Rings" />
      </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.jsx